import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import formatStrategyBenchmarkRateOfReturn from "../../../../../lib/StrategyBenchmarkChart/formatStrategyBenchmarkRateOfReturn";
import { STRATEGY_BENCHMARK_CHART_COLORS } from "../../../../../lib/StrategyBenchmarkChart/strategyBenchmarkChartColors";
import FlexSeparatedRow from "../../FlexSeparatedRow";

const COMPARISON_DOT_COLORS = {
  wig20: STRATEGY_BENCHMARK_CHART_COLORS.wig20,
  mwig40: STRATEGY_BENCHMARK_CHART_COLORS.mwig40,
  swig80: STRATEGY_BENCHMARK_CHART_COLORS.swig80
};

const StrategyBenchmarkChartLegendItem = ({ dotColor, label, rate, locale }) => (
  <div className="flex items-center gap-1.5 shrink-0">
    <span
      className="w-1 h-1 rounded-full shrink-0"
      style={{ backgroundColor: dotColor }}
      aria-hidden="true"
    />
    <span
      className="text-sm font-semibold leading-100"
      style={{ color: dotColor }}
    >
      {label}
    </span>
    <span
      className={classNames(
        "text-sm font-semibold leading-100 whitespace-nowrap shrink-0",
        rate >= 0 ? "text-green-3" : "text-red-3"
      )}
    >
      {formatStrategyBenchmarkRateOfReturn(rate, locale)}
    </span>
  </div>
);

StrategyBenchmarkChartLegendItem.propTypes = {
  dotColor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired
};

const StrategyBenchmarkChartLegendCards = ({
  locale,
  translate,
  strategyLabelKey,
  comparisonType,
  comparisonOptions,
  rates
}) => {
  const selectedComparison = comparisonOptions.find(
    option => option.value === comparisonType
  );

  if (!selectedComparison) {
    return null;
  }

  return (
    <FlexSeparatedRow
      className="flex items-center gap-3 overflow-x-auto pb-0.5 flex-row flex-wrap"
      itemClassName="inline-flex items-center gap-3"
      separatorClassName="hr-vertical-1 hr-vertical_16 self-center"
    >
      <StrategyBenchmarkChartLegendItem
        key="strategy"
        dotColor={STRATEGY_BENCHMARK_CHART_COLORS.strategy.line}
        label={translate(strategyLabelKey)}
        rate={rates.strategy}
        locale={locale}
      />
      <StrategyBenchmarkChartLegendItem
        key={selectedComparison.value}
        dotColor={
          COMPARISON_DOT_COLORS[comparisonType] ||
          STRATEGY_BENCHMARK_CHART_COLORS.wig20
        }
        label={selectedComparison.label}
        rate={rates[comparisonType] ?? 0}
        locale={locale}
      />
    </FlexSeparatedRow>
  );
};

StrategyBenchmarkChartLegendCards.propTypes = {
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  strategyLabelKey: PropTypes.string.isRequired,
  comparisonType: PropTypes.string.isRequired,
  comparisonOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  rates: PropTypes.shape({
    strategy: PropTypes.number.isRequired
  }).isRequired
};

export default StrategyBenchmarkChartLegendCards;
